/** @format */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Enrolment } from 'common-typescript/types';
import { ComponentDowngradeMappings } from 'sis-common';

@Component({
    selector: 'app-processing-state-indicator',
    templateUrl: './processing-state-indicator.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ProcessingStateIndicatorComponent {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'student.common.components.enrolment.processingStateIndicatorNg',
        directiveName: 'appProcessingStateIndicator',
    };

    @Input() enrolment: Enrolment;
}
